export const buttons = {
    pending : 'Pending',
    approved : 'Approved',
    rejected : 'Rejected',
    import : "Import",
    export : "Export",
    new : "New"
}